import { useTranslation } from 'react-i18next';

import { Container, ErrorState, Header } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

export const ErrorBoundary = () => {
  const { t } = useTranslation(['common', 'invoiceTemplates']);

  return (
    <>
      <Header.Root>
        <Header.Content backTo={routes.invoiceTemplates} title={t('invoiceTemplates:createEdit.header.title.create')} />
      </Header.Root>

      <Container>
        <ErrorState onRetry={() => window.location.reload()} title={t('invoiceTemplates:details.error.title')} />
      </Container>
    </>
  );
};
